module.exports = __webpack_public_path__ + "img/ol.fdf9d687.svg";